export default __webpack_public_path__ + "static/953-acafe254e334552e3926f2e0ed257a02.gif";